/* eslint-disable  @typescript-eslint/no-explicit-any */
import React, { useMemo } from "react";
import Stack from "@mui/material/Stack";
import Badge from "@mui/material/Badge";
import { SearchInputComponent } from "../../../../common/components";
import { UserRequestsListFilterProps } from "./user-requests-list-filter.props";
import FilterIcon from "../../../../assets/icons/filter-icon.svg";
import "./user-requests-list-filter.scss";
import { useResourcePermissions } from "../../../../common/hooks/resource-permissions";
import MODULES from "../../../../constants/modules";
import { useLogin } from "../../../../common/hooks/useUser";

const UserRequestsListFilter: React.FC<UserRequestsListFilterProps> = (
  props: any
) => {
  const {
    isOpenFilter,
    setIsOpenFilter,
    onSearch,
    selectedUserRequestsListFilter,
  } = props;
  return (
    <div className="user-requests-list-search-filter-wrapper">
      <div className="user-requests-list-search-wrapper">
        <SearchInputComponent
          placeholder="Search by first name, last name, email etc.,"
          onSearch={onSearch}
        />
      </div>
      <div className="user-requests-list-filter-wrapper">
        <div
          className={`user-requests-list-icon-filter ${isOpenFilter ? "active-filter" : ""}`}
          onClick={() => setIsOpenFilter(!isOpenFilter)}
          tabIndex={0}
        >
          <Stack spacing={4} direction="row" sx={{ color: "action.active" }}>
            <Badge
              color="secondary"
              badgeContent={selectedUserRequestsListFilter}
            >
              <img src={FilterIcon} alt="Filter Icon" />
            </Badge>
          </Stack>
        </div>
      </div>
    </div>
  );
};

export default UserRequestsListFilter;
